import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkDiagramComponent } from './network-diagram.component';

@NgModule({
    declarations: [NetworkDiagramComponent],
    exports: [
        NetworkDiagramComponent
    ],
    imports: [
        CommonModule
    ]
})
export class NetworkDiagramModule { }
